// // import React from 'react';
// // import { BrowserRouter as Router, Route, Switch, Link } from 'react-router-dom';
// // import { CssBaseline, Drawer, List, ListItem, ListItemText, AppBar, Toolbar, Typography } from '@mui/material';
// // import Summary from './Summary';
// // import CurrentMonth from './CurrentMonth';
// // import FutureMonth from './FutureMonth';
// // import Scheme from './Scheme';

// import React, { useEffect, useState } from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation,Link,Switch } from 'react-router-dom';
// import { CssBaseline, AppBar, Toolbar, IconButton, Drawer, List, ListItem, ListItemIcon, ListItemText, Divider, Typography } from '@mui/material';
// //import MenuIcon from '@mui/icons-material/Menu';
// import { Menu as MenuIcon, ChevronLeft as ChevronLeftIcon, WarehouseRounded } from '@mui/icons-material';
// import InboxIcon from '@mui/icons-material/MoveToInbox';
// import MailIcon from '@mui/icons-material/Mail';
// import { useMsal } from '@azure/msal-react';
// import axios from 'axios';
// import DataTable from './DataTable';
// import SchemeTable from './SchemeTable';
// import NewDataTable from './NewDataTable';
// import FutureTable from './FutureView';
// import HierarchicalTable from './HierarchicalTable';
// import WarehouseSelect from './Dropdown';
// import Login from './login';
import { ModalProvider } from "./ModalContext";

// const drawerWidth = 240;

// function App() {
//   const [open, setOpen] = useState(true); // State for toggling the drawer open/close
//   const [selectedMenu, setSelectedMenu] = useState('Summary');

//   const handleMenuClick = (menuName) => {
//     setSelectedMenu(menuName);
//   };

//   const toggleDrawer = () => {
//     setOpen(!open);
//   };
//   useEffect(() => {
//     // Set the default title
//     document.title = 'Month Planner';
//   }, []);

//   return (
//     <Router>
//       <div style={{ display: 'flex' }}>
//         <CssBaseline />
//         <AppBar
//           position="fixed"
//           style={{ width: `calc(100% - ${open ? drawerWidth : 0}px)`, marginLeft: open ? drawerWidth : 0,backgroundColor:"#149485",color:"white" }}
//         >
//           <Toolbar>
//             <IconButton
//               color="inherit"
//               aria-label="open drawer"
//               onClick={toggleDrawer}
//               edge="start"
//               sx={{ marginRight: '36px' }}
//             >
//               {open ? <ChevronLeftIcon /> : <MenuIcon />}
//             </IconButton>
//             <Typography variant="h6" noWrap>
//               {selectedMenu}
//             </Typography>
//           </Toolbar>
//         </AppBar>
//         <Drawer
//           sx={{
//            // width: drawerWidth,
//             flexShrink: 0,
//             '& .MuiDrawer-paper': {
//               //width: '30px',
//               transition: 'width 0.3s', // Smooth transition for drawer open/close
//               boxSizing: 'border-box',
//               backgroundColor: '#149485', // Drawer background color
//               color: 'white', // Drawer text color
//             },
//           }}
//           variant="persistent"
//           anchor="left"
//           open={open}

//         >
//           <List>

//             <ListItem button component={Link} to="/" onClick={() => handleMenuClick('Summary')}>
//               <ListItemText primary="Summary" />
//             </ListItem>
//             <ListItem button component={Link} to="/current-month" onClick={() => handleMenuClick('Current Month')}>
//               <ListItemText primary="Current Month" />
//             </ListItem>
//             <ListItem button component={Link} to="/future-month" onClick={() => handleMenuClick('Future Month')}>
//               <ListItemText primary="Future Month" />
//             </ListItem>
//             <ListItem button component={Link} to="/scheme" onClick={() => handleMenuClick('Scheme')}>
//               <ListItemText primary="Scheme" />
//             </ListItem>
//             <ListItem button component={Link} to="/dropdown" onClick={() => handleMenuClick('dropdown')}>
//               <ListItemText primary="dropdown" />
//             </ListItem>
//           </List>
//         </Drawer>
//         <main style={{ flexGrow: 1, padding: '20px', marginLeft: open ? drawerWidth : 0 }}>
//           <Toolbar />
//           <ModalProvider>
//           <Routes>
//             <Route path="/" element={<HierarchicalTable />} />
//             <Route path="/current-month" element={<DataTable />} />
//             <Route path="/future-month" element={<FutureTable />} />
//             <Route path="/scheme" element={<SchemeTable />} />
//             <Route path="/dropdown" element={<WarehouseSelect />} />
//           </Routes>
//           </ModalProvider>
//         </main>
//       </div>
//     </Router>
//   );
// }

// export default App;

// src/App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";


import { msalConfig } from "./authConfig";
import AppRoutes from "./AppRoutes";
import Sidebar from "./Sidebar";
import "./App.css";
import ToasterProvider from "./components/Toaster";

const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  const [isUserValidated, setIsUserValidated] = useState(() => {
    // Initialize state from localStorage
    return localStorage.getItem("userValidated") === "true";
  });
  const [open, setOpen] = useState(false);
  const handleUserValidated = () => {
    setIsUserValidated(true);
    localStorage.setItem("userValidated", "true");
  };
  useEffect(() => {
    if (!isUserValidated) {
      setOpen(false);
    }
  }, [isUserValidated]);

  return (
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <ModalProvider>
          <div className='app'>
            {isUserValidated && <Sidebar open={open} setOpen={setOpen} />}
            <div className={isUserValidated ? "content" : ""}>
              <AppRoutes
                onUserValidated={handleUserValidated}
                isUserValidated={isUserValidated}
                open={open}
              />
            </div>
          </div>
        </ModalProvider>
        <ToasterProvider />
      </BrowserRouter>
    </MsalProvider>
  );
}

export default App;
